export default {
  props: {
    keyName: String,
    value: {
      type: [ Date, Number, String ],
      default() { return new Date() }
    },
    format: {
      type: String,
      default: 'yyyy-mm-dd'
    },
    minDate: {
      type: [ Date, Number, String ],
      default() {
        const date = new Date()
        date.setFullYear(date.getFullYear() - 10)
        return date
      }
    },
    maxDate: {
      type: [ Date, Number, String ],
      default() {
        const date = new Date()
        date.setFullYear(date.getFullYear() + 10)
        return date
      }
    },
    weekStartDay: {
      type: Number,
      default: 0
    },
  },
  data() {
    const selectedDate = toZeroTimes(this.value)
    const today = toZeroTimes(new Date())
    selectedDate.week = getWeekInfo(selectedDate)
    return {
      selectedDate, today,
      currentYear: selectedDate.getFullYear(),
      currentMonth: selectedDate.getMonth()
    }
  },
  watch: {
    selectedDate(val) {
      val.week = getWeekInfo(val)
      this.syncCurrentAndSelected()
      this.$emit('change', val)
    },
    currentYear(val) {
      if (val === this.minYear && this.currentMonth < this.minMonth) this.currentMonth = this.minMonth
      else if (val === this.maxYear&& this.currentMonth > this.maxMonth) this.currentMonth = this.maxMonth
    },
    minDateObject(val) {
      if (new Date(this.currentYear, this.currentMonth, val.getDate()) < val) {
        this.currentYear = val.getFullYear()
        this.currentMonth = val.getMonth()
      }
    },
    maxDateObject(val) {
      if (new Date(this.currentYear, this.currentMonth, val.getDate()) > val) {
        this.currentYear = val.getFullYear()
        this.currentMonth = val.getMonth()
      }
    }
  },
  computed: {
    minDateObject() {
      return toZeroTimes(this.minDate)
    },
    maxDateObject() {
      return toZeroTimes(this.maxDate)
    },
    minYear() {
      return this.minDateObject.getFullYear()
    },
    maxYear() {
      return this.maxDateObject.getFullYear()
    },
    minMonth() {
      return this.minDateObject.getMonth()
    },
    maxMonth() {
      return this.maxDateObject.getMonth()
    },
    nextMonthDisabled() {
      let year = this.currentYear, month = this.currentMonth + 1
      if (month > 11) { year++; month = 0}

      return new Date(year, month, this.maxDateObject.getDate()) > this.maxDateObject
    },
    prevMonthDisabled() {
      let year = this.currentYear, month = this.currentMonth - 1
      if (month < 0) { year--; month = 11}
      
      return new Date(year, month, this.minDateObject.getDate()) < this.minDateObject
    },
    nextYearDisabled() {
      return this.currentYear >= this.maxDateObject.getFullYear()
    },
    prevYearDisabled() {
      return this.currentYear <= this.minDateObject.getFullYear()
    },
    
    //ui에서 쓸꺼용
    selectableYearList() {
      let minYear = this.minDateObject.getFullYear(), maxYear = this.maxDateObject.getFullYear(), result = []
      while(minYear <= maxYear) {
        result.push(minYear)
        minYear++
      }
      return result
    },
    selectableMonthList() {
      if (this.currentYear === this.minYear && this.currentYear === this.maxYear) {
        return _.times(12 - this.minMonth - (12 - this.maxMonth) + 1, num => num + this.minMonth)
      } else if (this.currentYear === this.minYear) {
        return _.times(12 - this.minMonth, num => num + this.minMonth)
      } else if (this.currentYear === this.maxYear) {
        return _.times(this.maxMonth + 1, Number)
      } else {
        return _.times(12, Number)
      }
    },
    // 일단 일요일 기준으로 작업함. 
    dateList() {
      let result = [], loopDate = new Date(this.currentYear, this.currentMonth), endDate

      endDate = new Date(loopDate)
      endDate.setMonth(endDate.getMonth() + 1)
      endDate.setDate(0)
      endDate.setDate(endDate.getDate() + 6 - (endDate.getDay()))
      loopDate.setDate(-(loopDate.getDay()) + 1)

      while(loopDate <= endDate) {
        const date = new Date(loopDate)
        const week = getWeekInfo(date, this.selectedDate)
        date.isCurrentMonth = loopDate.getMonth() === this.currentMonth
        date.isSelectedDate = loopDate.getTime() === this.selectedDate.getTime()
        date.isSelectedWeek = this.selectedDate >= week.startDate && this.selectedDate <= week.endDate,
        date.week = week
        date.disabled = loopDate < this.minDateObject || loopDate > this.maxDateObject
        date.isToday = loopDate.getTime() === this.today.getTime()
        result.push(date)
        loopDate.setDate(loopDate.getDate() + 1)
      }
      return _.chunk(result, 7)
    },
    dayList() {
      return ['일', '월', '화', '수', '목', '금', '토']
    }
  },
  methods: {
    setDate(date) {
      const result = toZeroTimes(date)
      const overDate = result < this.minDateObject || result > this.maxDateObject
      if (isNaN(result) || overDate) {
        this.$emit('setDateError', overDate ? 'overDate' : 'invalid')
        this.$forceUpdate()
        return
      }
      this.selectedDate = result
    },
    // 내부 사용금지. 외부에서 override 할수 있음
    getDate() {
      return new Date(this.selectedDate)
    },
    // 증감
    tickCurrentMonth(val) {
      if ((val < 0 && this.prevMonthDisabled) || (val > 0 && this.nextMonthDisabled)) return

      let result = this.currentMonth + val
      if (result < 0) {
        this.currentYear--
        result = 11
      }
      else if (result >= 12) {
        this.currentYear++
        result = 0
      }
      this.currentMonth = result
    },
    tickCurrentYear(val) {
      if ((val < 0 && this.prevYearDisabled) || (val > 0 && this.nextYearDisabled)) return
      this.currentYear += val
    },
    syncCurrentAndSelected() {
      this.currentYear = this.selectedDate.getFullYear()
      this.currentMonth = this.selectedDate.getMonth()
    }
  }
}

// (시간, 분, 초, 밀리초)를 0으로 설정한 새로운 객체 반환
function toZeroTimes(date) {
  const result = new Date(date)
  result.setHours(0, 0, 0, 0)
  return result
}

function getWeekInfo(date) {
  const startDate = toZeroTimes(date)
  startDate.setDate(startDate.getDate() - startDate.getDay())
  const endDate = new Date(startDate)
  endDate.setDate(endDate.getDate() + 6)
  endDate.setHours(23, 59, 59, 999)

  return {
    // isContains: d2 >= startDate && d2 <= endDate,
    startDate, endDate
  }
}
